import { FC, ReactNode } from "react";
import { Sparkles } from "lucide-react";
import { AppearedContent } from "../../DataDisplay/AppearedContent";

const defaultIcon = (isActive?: boolean) => (
  <Sparkles
    width="15"
    height="15"
    className={`${
      isActive
        ? "text-stone-400 dark:text-stone-200"
        : "text-white dark:text-stone-900"
    }`}
  />
);

const keynoteIcon = (icon: ReactNode, isActive: boolean, index = 0) => (
  <div
    key={index}
    className={`flex h-6 min-w-6 items-center justify-center rounded-full  ${
      isActive
        ? "bg-stone-50 dark:bg-stone-600"
        : "bg-stone-200 dark:bg-stone-700"
    }`}
  >
    {icon}
  </div>
);

const KeynoteSpan = (content: string, index = 0) => {
  return (
    <span
      className="whitespace-nowrap border-white dark:border-stone-500"
      key={index}
    >
      {content}
    </span>
  );
};

type DetailKeynoteProps = {
  icons?: ReactNode[];
  items?: string[];
  noItemsMessage?: string;
  appearingItems?: number;
};
export const DetailKeynote: FC<DetailKeynoteProps> = ({
  icons = [],
  items,
  noItemsMessage = "No active Nets",
  appearingItems = 1,
}) => {
  const isActive = !(items && items.length === 0);
  const renderAppearing = items ? 0 : appearingItems;
  return (
    <div
      className={`text-primary mt-4 flex h-8 max-w-fit items-center rounded-full py-1.5 pl-1 pr-1
      ${
        isActive
          ? "bg-stone-100 dark:bg-stone-900"
          : "border border-stone-200 dark:border-none dark:bg-stone-900"
      }`}
    >
      {icons?.length > 0
        ? icons.map((icon, index) => {
            return keynoteIcon(icon, isActive, index);
          })
        : keynoteIcon(defaultIcon(isActive), isActive)}

      <div className="no-scrollbar ml-2 mr-2 overflow-auto text-sm text-stone-700 dark:text-white [&>*:not(:first-child)]:pl-2 [&>*:not(:last-child)]:border-r [&>*:not(:last-child)]:pr-2 ">
        {renderAppearing > 0 && (
          <AppearedContent
            isLoaded={false}
            skeletonOptions={{
              amount: renderAppearing,
              skeletonStyle: "iconStyle",
            }}
          />
        )}
        {items && items.map((item, index) => KeynoteSpan(item, index))}
        {!isActive && KeynoteSpan(noItemsMessage)}
      </div>
    </div>
  );
};
